import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { useNavigate } from 'react-router';
import moment from 'moment';

import TableView from '../Table/Table';
import { Panel, PanelBody, PanelHeader } from "../../header/panel/panel"

import { addProcessingGroupHistory, fetchProcessingGroupHistory, deleteProcessingGroupHistory } from '../../../redux/actions/ProcessingGroupActions';
import { fetchHistoryProcessorTerminals } from '../../../redux/actions/DropdownActions';
import { fetchProcessorTerminalsForAssignment } from '../../../redux/actions/DropdownActions';
import { setProcessorTerminalID } from '../../../redux/actions/ProcessorTerminalActions';

import { CREDITBLOCK } from '../../../utils/constants';
import SweetAlert from 'react-bootstrap-sweetalert';


const ProcessingGroupHistory = (props) => {

    useNavigate()

    const [delModelOpen, setDelModelOpen] = useState(false);
    const [addModelOpen, setAddModelOpen] = useState(false)

    const [data, setData] = useState(null)

    const [processorTermID, setProcessorTermID] = useState('')
    useState('')
    const [connectionID, setConnectionID] = useState('')
    const [processingGroupID, setProcessingGroupID] = useState('')
    const [processorID, setProcessorID] = useState('')
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null)
    const [importTransactions, setImportTransactions] = useState(true)

    const [, setProcessorTermIDError] = useState(false)
    const [, setConnectionIDError] = useState(false)
    const [processorIDError] = useState(false)
    const [startDateError, setStartDateError] = useState(false)
    const [, setEndDateError] = useState(false)
    const [importTransactionsError, setImportTransactionsError] = useState(false)

    const [connectionsDropdown, setConnectionsDropdown] = useState([])
    const [, setProcessorTerminalsDropdown] = useState([])




    useEffect(() => {
        let processingGroupID = props.processingGroupID;
        if (processingGroupID) {
            setProcessingGroupID(props.processingGroupID)
            props.fetchProcessingGroupHistory(processingGroupID)
            props.fetchHistoryProcessorTerminals()
        }
    }, [])


    const handleDeleteConfirmation = () => {

        let body = {}
        body.processorTermID = data?.data?.processorTermID
        body.processingGroupID = processingGroupID

        if (body.processorTermID, body.processingGroupID) {
            console.log('Delete History : ', body)
            props.deleteProcessingGroupHistory(body)
            setDelModelOpen(false)
        }



    }
    const handleDeleteButton = (value) => {
        setDelModelOpen(true)
    }

    const onCellClicked = (value) => {
        setData(value)
    }

    const handleAddButton = (value) => {
        setAddModelOpen(true)
    }

    const handleChange = (event) => {

        let targetName = event.target.name
        let targetValue = event.target.value
        switch (targetName) {
            case 'processorID':
                setProcessorID(targetValue)
                let connections = props.DROPDOWNREDUCER.historyProcessorTerminals.filter(processor => {
                    return Number(processor.processorID) === Number(targetValue) // eslint-fix: preserve loose-equality coercion
                })
                setConnectionsDropdown(connections[0]?.processorConnections)
                break;
            case 'connectionID':
                setConnectionID(targetValue)
                let processorTerminal = connectionsDropdown.filter(connection => {
                    return Number(connection.connectionID) === Number(targetValue) // eslint-fix: preserve loose-equality coercion
                })
                setProcessorTerminalsDropdown(processorTerminal[0]?.processorTermID)
                break;
            case 'processorTermID':
                setProcessorTermID(targetValue)
                setProcessorTermIDError(false)
                break;
            case 'startDate':
                setStartDate(targetValue)
                setStartDateError(false)
                break;
            case 'endDate':
                setEndDate(targetValue)
                setEndDateError(false)
                break;
            case 'importTransactions':
                setImportTransactions(targetValue)
                setImportTransactionsError(false)
                break;
            default:
                break;

        }

    }


    const handleAdd = () => {

        let body = {}

        if (processorTermID) {
            body.processorTermID = processorTermID
        } else {
            setProcessorTermIDError(true)
        }

        if (connectionID) {
            body.connectionID = connectionID
        } else {
            setConnectionIDError(true)
        }


        if (processingGroupID) {
            body.processingGroupID = processingGroupID
        }
        if (startDate) {
            body.startDate = startDate
        } else {
            startDateError(true)
        }
        if (endDate) {
            body.endDate = endDate
        } else {
            setEndDateError(true)
        }
        if (importTransactions) {
            body.importTransactions = importTransactions
        } else {
            importTransactionsError(true)
        }

        if (body.processorTermID, body.processingGroupID, body.connectionID, body.startDate, body.endDate, !importTransactionsError) {
            // console.log('Data : ', body)
            props.addProcessingGroupHistory(body)
            setAddModelOpen(false)
        }



    }

    const DELETE_CONFIRMATION = (
        <p className="lead text-dark">
            <SweetAlert danger showCancel
                confirmBtnText="Yes!"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                onConfirm={handleDeleteConfirmation}
                onCancel={() => setDelModelOpen(!delModelOpen)}
            >

                <b> Are you sure you want to remove - {data?.data?.processorTermID}</b>

            </SweetAlert>
        </p>
    )

    const ADD_HISTORY_FORM = (
        <p className="lead text-dark ">

            <SweetAlert showCancel
                confirmBtnText="Add"
                cancelBtnBsStyle="default"
                onConfirm={handleAdd}
                onCancel={() => setAddModelOpen(!addModelOpen)}
            >

                <Panel >
                    <PanelHeader>PROCESSING GROUP HISTORY FORM</PanelHeader>
                    <PanelBody>

                        <form className="fs-13px">

                            <div className="mb-3">

                                <div className="row gx-6">

                                    <div className="col-md-12 mb-12 mb-md-2">
                                        <label className={"col-md-3 " + (processorIDError ? 'text-danger' : '')} ><b>Processor</b></label>
                                        <select className="form-select"
                                            onChange={handleChange}
                                            name='processorID'
                                            value={processorID ? processorID : ' '}
                                        >
                                            <option value=''>Select Processor</option>
                                            {props.DROPDOWNREDUCER.processorTerminals.length > 0 ? props.DROPDOWNREDUCER.processorTerminals.map((option) => (
                                                <option key={option.processorID} value={option.processorID}>
                                                    {option.processorName}
                                                </option>
                                            ))
                                                : <></>
                                            }

                                        </select>
                                    </div>
                                    <div className="col-md-12 mb-12 mb-md-2">
                                        <label className={"col-md-3 " + (processorIDError ? 'text-danger' : '')} ><b>Connection</b></label>
                                        <select className="form-select"
                                            onChange={handleChange}
                                            name='connectionID'
                                            value={connectionID ? connectionID : ''}
                                        >
                                            <option value=''>Select Connection</option>
                                            {connectionsDropdown.map((option) => (
                                                <option key={option.processorID} value={option.processorID}>
                                                    {option.processorName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-12 mb-12 mb-md-2">

                                        <label className={"col-md-12 " + (importTransactionsError ? 'text-danger' : '')}><b>Import Transactions</b></label>

                                        <select className="form-select"
                                            value={importTransactions ? importTransactions : true}
                                            onChange={handleChange}
                                            name='importTransactions'
                                        >
                                            {CREDITBLOCK.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.status}
                                                </option>
                                            ))}

                                        </select>
                                    </div>

                                    <div className="col-md-12 mb-12 mb-md-2">

                                        <label className="col-md-12"><b>Processor TID</b></label>
                                        <input
                                            name="processorTermID"
                                            value={processorTermID ? processorTermID : ''}
                                            onChange={handleChange}
                                            type="text"
                                            className="form-control fs-13px"
                                        ></input>
                                    </div>

                                    <div className="col-md-12 mb-12 mb-md-2">
                                        <label className="form-check-label" >
                                            <b>Start Date</b>
                                        </label>
                                        <input
                                            label="Start Date"
                                            type="date"
                                            onChange={handleChange}
                                            name="startDate"
                                            className="form-control fs-13px"
                                        ></input>
                                    </div>

                                    <div className="col-md-12 mb-12 mb-md-2">
                                        <label className="form-check-label" >
                                            <b>End Date</b>
                                        </label>

                                        <input
                                            label="End Date"
                                            type="date"
                                            onChange={handleChange}
                                            name="endDate"
                                            className="form-control fs-13px"
                                        ></input>
                                    </div>

                                </div>
                            </div>

                        </form>

                    </PanelBody>
                </Panel>
            </SweetAlert>
        </p>
    )

    const historyHeadings = {

        prefixHeadings: [
            { field: 'processorTermID', tooltipField: 'processorTermID', headerName: 'P TID', minWidth: 110, maxWidth: 105 },
            {
                field: 'createDate', tooltipField: 'createDate', headerName: 'Start Date', minWidth: 120, maxWidth: 115, cellRenderer: function (params) {
                    return params.value ? moment(params.value).format('MMM DD, YYYY') : "N/A";
                }
            },
            {
                field: 'endDate', tooltipField: 'endDate', headerName: 'End Date', minWidth: 120, maxWidth: 120, cellRenderer: function (params) {
                    return params.value ? moment(params.value).format('MMM DD, YYYY') : "N/A";
                }
            },
            {
                field: 'importTransactions', headerName: 'Import', cellRenderer: function (params) {
                    return Number(params.value) === 1 ? 'Yes' : 'No'; // eslint-fix: preserve loose-equality coercion
                }
            }, {
                field: 'Action', tooltipField: 'action', headerName: '', minWidth: 80, cellRenderer: function (params) {
                    return <button className="btn btn-danger btn-icon btn-circle btn-sm me-1" onClick={handleDeleteButton}>X</button>
                }
            },
        ]
    }


    return (

        <Panel>

            <PanelHeader>

                <div className="row mb-0">
                    <div className="col-xl-9">
                        <b>PROCESSING HISTORY</b>
                    </div>
                    <div className="col-xl-3">
                        <button className='btn btn-secondary btn-xs' onClick={handleAddButton}>Add History</button>
                    </div>
                </div>

            </PanelHeader>

            < TableView height={300} headings={historyHeadings.prefixHeadings} data={props.PROCESSORGROUPSREDUCER.processingGroupHistory[processingGroupID]} handleClick={onCellClicked} />

            {delModelOpen ?
                DELETE_CONFIRMATION : null
            }
            {addModelOpen ?
                ADD_HISTORY_FORM : null
            }
        </Panel>

    )

}
function mapStateToProps(state) {
    return state
}

const mapDispatchToProps = {
    addProcessingGroupHistory,
    deleteProcessingGroupHistory,
    fetchProcessingGroupHistory,
    fetchProcessorTerminalsForAssignment,
    setProcessorTerminalID,
    fetchHistoryProcessorTerminals

}


export default connect(mapStateToProps, mapDispatchToProps)(ProcessingGroupHistory);
